import { BASE_URL } from 'config/urls';

import { post, requestSdk } from 'utils/sdk';

export const logout = async () => {
  return await requestSdk(() => post(`${BASE_URL}/v1/auth/logout/`));
};
